import { render, staticRenderFns } from "./ImTip.vue?vue&type=template&id=08d562f1"
import script from "./ImTip.vue?vue&type=script&lang=js"
export * from "./ImTip.vue?vue&type=script&lang=js"
import style0 from "./ImTip.vue?vue&type=style&index=0&id=08d562f1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports